import React from 'react';
import { ExperienceStart } from '@atlassian/jira-experience-tracker';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';

type Props = {
	experienceId: string;
	experience: string;
	analyticsSource: string;
};

export const SoftwareExperienceStart = ({ experienceId, experience, analyticsSource }: Props) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={experience}
			analyticsSource={analyticsSource}
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};
